import { format, parse } from 'date-fns';
import { List } from 'immutable';
import { createSelector } from 'reselect';

import { selectedStructure } from '@sophocles/features/sites/slices/selectedStructure/selectors';

export const annualSolarReportSelector = state => state.entities.annualSolarReports;

export const getAnnualSolarReportSelector = createSelector(annualSolarReportSelector, reports =>
  reports.map(report => {
    const todayFormatted = format(new Date(), 'yyyy-MM-dd');
    return report.toMap().set('moment', parse(report.get('year_end_date', todayFormatted), 'yyyy-MM-dd', new Date()));
  }),
);

export const getAnnualSolarReportsForSelectedStructure = createSelector(
  selectedStructure,
  getAnnualSolarReportSelector,
  (structure, reports) => {
    if (structure < -1) {
      return List();
    }
    return reports.filter(report => report.get('site', -1) == structure).toList();
  },
);
